var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-md-4",staticStyle:{"padding-bottom":".4em"}},[_c('span',{staticClass:"form-label"},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('br'),_c('span',{staticClass:"form-value"},[_vm._v(" "+_vm._s(_vm.value || '--')+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }